import i18next from 'i18next';
import { CombinedSensorTagType, SensorTagType } from 'constants/sensorTags';

export const sensorCarbonDioxideTagLiterals = {
  [CombinedSensorTagType.BUILDING_CARBON_DIOXIDE]: () => i18next.t('_SENSOR_TAG_LABEL_BUILDING_CARBON_DIOXIDE'),
};

export const sensorHumidityTagLiterals = {
  [CombinedSensorTagType.STREET_HUMIDITY]: () => i18next.t('_SENSOR_TAG_LABEL_STREET_HUMIDITY'),
  [CombinedSensorTagType.BUILDING_HUMIDITY]: () => i18next.t('_SENSOR_TAG_LABEL_BUILDING_HUMIDITY'),
};

export const sensorIlluminanceTagLiterals = {
  [CombinedSensorTagType.BUILDING_ILLUMINANCE]: () => i18next.t('_SENSOR_TAG_LABEL_BUILDING_ILLUMINANCE'),
};

export const sensorKilowattsHourTagLiterals = {
  [CombinedSensorTagType.BUILDING_ENERGY]: () => i18next.t('_SENSOR_TAG_LABEL_BUILDING_ENERGY'),
  [CombinedSensorTagType.BUILDING_POWER]: () => i18next.t('_SENSOR_TAG_LABEL_BUILDING_POWER'),
  [CombinedSensorTagType.DOMESTIC_ENERGY_GENERAL]: () => i18next.t('_SENSOR_TAG_LABEL_DOMESTIC_ENERGY_GENERAL'),
  [CombinedSensorTagType.THERMAL_ENERGY_HEAT]: () => i18next.t('_SENSOR_TAG_LABEL_THERMAL_ENERGY_HEAT'),
  [CombinedSensorTagType.THERMAL_ENERGY_COOLING]: () => i18next.t('_SENSOR_TAG_LABEL_THERMAL_ENERGY_COOLING'),
  [CombinedSensorTagType.THERMAL_ENERGY_HEAT_AUTO_BILLING]: () => i18next.t('_SENSOR_TAG_LABEL_THERMAL_ENERGY_HEAT_AUTO_BILLING'),
  [CombinedSensorTagType.THERMAL_ENERGY_COOLING_AUTO_BILLING]: () => i18next.t('_SENSOR_TAG_LABEL_THERMAL_ENERGY_COOLING_AUTO_BILLING'),
  [CombinedSensorTagType.DOMESTIC_ENERGY_GENERAL_AUTO_BILLING]: () => i18next.t('_SENSOR_TAG_LABEL_DOMESTIC_ENERGY_GENERAL_AUTO_BILLING'),
};

export const sensorPeopleFlowTagLiterals = {
  [CombinedSensorTagType.PEOPLE_FLOW_IN]: () => i18next.t('_SENSOR_TAG_LABEL_PEOPLE_FLOW_IN'),
  [CombinedSensorTagType.PEOPLE_FLOW_OUT]: () => i18next.t('_SENSOR_TAG_LABEL_PEOPLE_FLOW_OUT'),
};

export const sensorTemperatureTagLiterals = {
  [CombinedSensorTagType.STREET_TEMPERATURE]: () => i18next.t('_SENSOR_TAG_LABEL_STREET_TEMPERATURE'),
  [CombinedSensorTagType.BUILDING_TEMPERATURE]: () => i18next.t('_SENSOR_TAG_LABEL_BUILDING_TEMPERATURE'),
};

export const sensorVolumeTagLiterals = {
  [CombinedSensorTagType.BUILDING_GAS]: () => i18next.t('_SENSOR_TAG_LABEL_BUILDING_GAS'),
  [CombinedSensorTagType.BUILDING_COLD_WATER]: () => i18next.t('_SENSOR_TAG_LABEL_BUILDING_COLD_WATER'),
  [CombinedSensorTagType.BUILDING_HOT_WATER]: () => i18next.t('_SENSOR_TAG_LABEL_BUILDING_HOT_WATER'),
  [CombinedSensorTagType.BUILDING_WATER]: () => i18next.t('_SENSOR_TAG_LABEL_BUILDING_WATER'),
  [CombinedSensorTagType.DOMESTIC_WATER_GENERAL]: () => i18next.t('_SENSOR_TAG_LABEL_DOMESTIC_WATER_GENERAL'),
  [CombinedSensorTagType.DOMESTIC_HOT_WATER]: () => i18next.t('_SENSOR_TAG_LABEL_DOMESTIC_HOT_WATER'),
  [CombinedSensorTagType.DOMESTIC_COLD_WATER]: () => i18next.t('_SENSOR_TAG_LABEL_DOMESTIC_COLD_WATER'),
  [CombinedSensorTagType.DOMESTIC_WATER_GENERAL_AUTO_BILLING]: () => i18next.t('_SENSOR_TAG_LABEL_DOMESTIC_WATER_GENERAL_AUTO_BILLING'),
  [CombinedSensorTagType.DOMESTIC_HOT_WATER_AUTO_BILLING]: () => i18next.t('_SENSOR_TAG_LABEL_DOMESTIC_HOT_WATER_AUTO_BILLING'),
  [CombinedSensorTagType.DOMESTIC_COLD_WATER_AUTO_BILLING]: () => i18next.t('_SENSOR_TAG_LABEL_DOMESTIC_COLD_WATER_AUTO_BILLING'),
};

export const combinedSensorTagLiterals: Record<SensorTagType, () => string> = {
  ...sensorCarbonDioxideTagLiterals,
  ...sensorHumidityTagLiterals,
  ...sensorIlluminanceTagLiterals,
  ...sensorKilowattsHourTagLiterals,
  ...sensorPeopleFlowTagLiterals,
  ...sensorTemperatureTagLiterals,
  ...sensorVolumeTagLiterals,
};

export const defaultTagValues = Object.values(CombinedSensorTagType);

export const mapTagsToLabels = (tags: string[]): { label: string; value: string }[] => {
  return tags.map((tag) => {
    const hasTagLiteral = defaultTagValues.includes(tag as SensorTagType);
    const label = hasTagLiteral ? combinedSensorTagLiterals[tag as SensorTagType]() : tag;

    return { label, value: tag };
  });
};
